import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ALAIN_I18N_TOKEN } from '@delon/theme';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { I18NService } from 'src/app/core';
import { TestIdDirective } from 'src/app/shared/directives/test-id.directive';

import { RobotChatTestComponent } from '../robot-chat-test/robot-chat-test.component';

type RobotAnswerTestModalData = {
  serviceNumberId: string;
  robotId?: string | null;
  robotName?: string | null;
};

@Component({
  selector: 'robot-answer-test-modal',
  standalone: true,
  imports: [CommonModule, NzButtonModule, RobotChatTestComponent, TestIdDirective],
  template: `<robot-chat-test testId="robot-answer-test-chat" />`,
  styles: [
    `
      :host {
        display: block;
      }
    `
  ]
})
export class RobotAnswerTestModalComponent {
  private readonly modalRef = inject(NzModalRef);
  readonly i18n = inject<I18NService>(ALAIN_I18N_TOKEN);
  readonly modalData: RobotAnswerTestModalData = inject(NZ_MODAL_DATA, { optional: true }) || { serviceNumberId: '' };
}
